// Custom hook for user permissions and UI control
import { useState, useEffect } from 'react';
import { useFileContext } from '../ContextAPI/FileContext';

export const useUserPermissions = () => {
  const { verifyTokenAndPrivileges, getUserAccessLevel } = useFileContext();
  const [permissions, setPermissions] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPermissions();
  }, []);

  const loadPermissions = async () => {
    try {
      setLoading(true);
      const accessLevel = await getUserAccessLevel();
      
      const uiPermissions = {
        // Navigation items they can see
        canSeeAdminPanel: accessLevel.permissions.includes('access_admin_panel'),
        canSeeManagementPanel: accessLevel.permissions.includes('access_management_panel'),
        canSeeUserManagement: accessLevel.permissions.includes('manage_users'),
        
        // Actions they can perform
        canDeleteUsers: accessLevel.permissions.includes('delete_users'),
        canAssignAdmin: accessLevel.permissions.includes('assign_admin'),
        canManageSystemSettings: accessLevel.permissions.includes('manage_system_settings'),
        canViewAllData: accessLevel.permissions.includes('view_all_data'),
        canUploadFiles: accessLevel.permissions.includes('upload_files'),
        
        // Access level for conditional rendering
        isAdmin: accessLevel.level >= 3,
        isManager: accessLevel.level >= 2,
        isUser: accessLevel.level >= 1,
        
        // Raw data
        level: accessLevel.level,
        groups: accessLevel.groups,
        permissions: accessLevel.permissions
      };
      
      setPermissions(uiPermissions);
    } catch (error) {
      console.error('Error loading permissions:', error);
      setPermissions({
        isAdmin: false,
        isManager: false,
        isUser: false,
        level: 0,
        groups: [],
        permissions: []
      });
    } finally {
      setLoading(false);
    }
  };

  const refreshPermissions = () => {
    loadPermissions();
  };

  return {
    permissions,
    loading,
    refreshPermissions
  };
};
